export { buildGroupFieldName, parseGroupFieldName, isSameGroup, isSameField, getGroupIndex, GROUP_SEP };

const GROUP_SEP = '__';
const groupFieldNameRE = new RegExp(
  `(?<groupName>[a-zA-Z0-9]+)${GROUP_SEP}(?<index>\\d+)${GROUP_SEP}(?<fieldName>[a-zA-Z0-9]+)`,
);

function buildGroupFieldName(name: string, index: number, field: string) {
  return name + GROUP_SEP + index + GROUP_SEP + field;
}

function parseGroupFieldName(name: string) {
  const res = name.match(groupFieldNameRE);
  const ret = {
    fieldName: '',
    index: -1,
    groupName: '',
  };

  if (res?.groups) {
    ret.fieldName = res.groups.fieldName;
    ret.index = Number(res.groups.index);
    ret.groupName = res.groups.groupName;
  }

  return ret;
}

function getGroupIndex(name: string, schemas: Record<string, any>) {
  const indexs = Object.keys(schemas).map((key) => {
    const { groupName, index } = parseGroupFieldName(key);
    return groupName === name ? index : -1;
  });

  return Math.max.apply(undefined, indexs);
}

function isSameGroup(name: string, groupName: string) {
  const { groupName: gn } = parseGroupFieldName(name);

  return gn === groupName;
}

function isSameField(name: string, fieldName: string) {
  const { fieldName: fn } = parseGroupFieldName(name);

  return fn === fieldName;
}
